import React from "react";
import ReactEcharts from "echarts-for-react";
import Skeleton from "react-loading-skeleton";
import noData from "../../assets/images/noData.png";

const TopLocationChart = ({ location, showLoading }) => {
  const processedLocation = location.map((l) => ({
    name: l.name && l.name.trim() !== "" ? l.name : "Other",
    value: l.value || 0,
  }));

  const locationOption = {
    tooltip: {
      trigger: "item",
      formatter: ({ name, value }) => `${name}: ${value}`,
    },
    legend: {
      orient: "vertical",
      left: "1%",
      top: "middle",
      formatter: (name) => {
        const item = processedLocation.find((a) => a.name === name);
        return `${name} - ${item.value}`;
      },
      textStyle: { color: "#111827", fontWeight: 500, fontSize: 13 },
    },
    series: [
      {
        name: "Applications",
        type: "pie",
        radius: ["40%", "70%"],
        center: ["62%", "50%"],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 10, borderColor: "#fff", borderWidth: 2 },
        label: {
          show: true,
          position: "outside",
          formatter: "{b}",
          color: "#1f2937",
          fontWeight: 500,
        },
        emphasis: { label: { show: true, fontSize: 13, fontWeight: 600 } },
        labelLine: { show: true },
        data: processedLocation,
      },
    ],
  };

  return (
    <div className="p-1">
      {showLoading ? (
        <Skeleton count={8} height="25px" />
      ) : location.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={noData} alt="No data" />
        </div>
      ) : (
        <>
          <ReactEcharts option={locationOption} />
        </>
      )}
    </div>
  );
};

export default TopLocationChart;
